/* My Prolearning — QCM : onglets UE + animations (vanilla, accessible). */
(function () {
  'use strict';
  var root = document.querySelector('.mpl-qcm');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var tabs = Array.prototype.slice.call(root.querySelectorAll('.qcm-tab'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('.qcm-panel'));

  function activate(ue, focusTab) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-ue') === ue;
      t.classList.toggle('on', on);
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      if (on && focusTab) t.focus();
    });
    panels.forEach(function (p) {
      var on = p.getAttribute('data-ue') === ue;
      p.classList.toggle('on', on);
      p.hidden = !on;
      if (on) {
        // (re)joue le reveal des éléments du panneau affiché
        p.querySelectorAll('.qcm-reveal').forEach(function (el) { el.classList.add('in'); });
      }
    });
  }

  tabs.forEach(function (tab, idx) {
    tab.addEventListener('click', function () { activate(tab.getAttribute('data-ue'), false); });
    // navigation clavier entre onglets (flèches, Home/End)
    tab.addEventListener('keydown', function (e) {
      var i = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') i = (idx + 1) % tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') i = (idx - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') i = 0;
      else if (e.key === 'End') i = tabs.length - 1;
      if (i !== null) { e.preventDefault(); activate(tabs[i].getAttribute('data-ue'), true); }
    });
  });
  // tabIndex initial (roving)
  tabs.forEach(function (t, i) { t.tabIndex = (i === 0 ? 0 : -1); });

  /* reveal au scroll */
  function fire(el) { el.classList.add('in'); }
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { fire(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.18 });
    // n'observe que les éléments du panneau visible + hors panneaux
    root.querySelectorAll('.qcm-reveal').forEach(function (el) {
      var panel = el.closest('.qcm-panel');
      if (panel && panel.hidden) { return; }
      io.observe(el);
    });
  } else {
    root.querySelectorAll('.qcm-reveal').forEach(fire);
  }

  /* parallaxe légère du fond */
  if (!reduce) {
    var qs = root.querySelectorAll('.qcm-bg .q');
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.pageYOffset;
        qs.forEach(function (g, i) { g.style.transform = 'translateY(' + (y * ((i % 3 + 1) * 0.03)) + 'px)'; });
        ticking = false;
      });
    }, { passive: true });
  }
})();
